import React, { useEffect, useState, useContext } from "react";
import { ThemeContext } from "../constant/theme";
import { CLIENT_ICON_EVENT } from "../utils/clientIcon";

const containerStyle = {
  position: "fixed",
  right: "12px",
  bottom: "24px",
  zIndex: 9998,
  pointerEvents: "auto",
};

// Circular floating badge (base)
const tagStyle = {
  position: "relative",
  width: "55px",
  height: "55px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  borderRadius: "50%",
  //boxShadow: "0 18px 30px rgba(15, 23, 42, 0.35)",
};

// Hide the notch for circular layout (kept for compatibility)
const notchStyle = {
  display: "none",
};

const iconFrameStyle = {
  width: "48px",
  height: "48px",
  borderRadius: "50%",
  overflow: "hidden",
  background: "rgba(255, 255, 255, 0.95)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 6px 14px rgba(15, 23, 42, 0.25)",
};

const iconStyle = {
  width: "36px",
  height: "36px",
  objectFit: "contain",
};

export default function ClientBadge() {
  const [iconUrl, setIconUrl] = useState(() => localStorage.getItem("clientIconUrl"));
  const [hasError, setHasError] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hideZone, setHideZone] = useState(null);
  const { theme } = useContext(ThemeContext);

  // compute background + border based on theme (only modify these)
  const computedTagStyle = {
    ...tagStyle,
    background: theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)",
    border: theme === "dark" ? "1px solid rgba(255,255,255,0.9)" : "1px solid rgba(148, 163, 184, 0.12)",
    opacity: isHovered ? 0 : 1,
  };

  useEffect(() => {
    const syncFromStorage = (event) => {
      if (!event || event.key === "clientIconUrl") {
        setHasError(false);
        setIconUrl(localStorage.getItem("clientIconUrl"));
      }
    };

    const handleCustom = (event) => {
      setHasError(false);
      if (event?.detail && Object.prototype.hasOwnProperty.call(event.detail, "iconUrl")) {
        setIconUrl(event.detail.iconUrl || null);
      } else {
        setIconUrl(localStorage.getItem("clientIconUrl"));
      }
    };

    window.addEventListener("storage", syncFromStorage);
    window.addEventListener(CLIENT_ICON_EVENT, handleCustom);

    return () => {
      window.removeEventListener("storage", syncFromStorage);
      window.removeEventListener(CLIENT_ICON_EVENT, handleCustom);
    };
  }, []);

  useEffect(() => {
    if (!iconUrl) {
      setHasError(false);
    }
  }, [iconUrl]);

  useEffect(() => {
    if (!isHovered) {
      return undefined;
    }

    const handleMouseMove = (event) => {
      if (!hideZone) {
        return;
      }

      const isInsideHideZone =
        event.clientX >= hideZone.left &&
        event.clientX <= hideZone.right &&
        event.clientY >= hideZone.top &&
        event.clientY <= hideZone.bottom;

      if (!isInsideHideZone) {
        setIsHovered(false);
        setHideZone(null);
      }
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [hideZone, isHovered]);

  if (!iconUrl || hasError) {
    return null;
  }

  return (
    <div
      className="client-badge"
      style={{
        ...containerStyle,
        pointerEvents: isHovered ? "none" : "auto",
      }}
      onMouseEnter={(event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setHideZone({
          left: rect.left,
          right: rect.right,
          top: rect.top,
          bottom: rect.bottom,
        });
        setIsHovered(true);
      }}
    >
      <div style={computedTagStyle}>
        <span style={notchStyle} />
        <div style={iconFrameStyle}>
          <img
            src={iconUrl}
            alt="Client badge"
            style={iconStyle}
            loading="lazy"
            onError={() => setHasError(true)}
          />
        </div>
      </div>
    </div>
  );
}
